import { render, staticRenderFns } from "./STableWorksDebtComp.vue?vue&type=template&id=2940fe4e&"
import script from "./STableWorksDebtComp.vue?vue&type=script&lang=js&"
export * from "./STableWorksDebtComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports